import hcSticky from 'hc-sticky';

/**
 * Set up sticky.
 */
class IconicSticky {
	/**
	 * Class names.
	 *
	 * @type {{}}
	 */
	classes = {
		'sticky': '.sticky',
	};

	/**
	 * Run panels.
	 */
	constructor() {
		this.initSticky();
	};

	/**
	 * Init sticky elements.
	 */
	initSticky = () => {
		var adminBar = document.getElementById( 'wpadminbar' ),
			top = null !== adminBar ? 32 : 0;

		new hcSticky( this.classes.sticky, {
			top: top,
			stickTo: '#inner-wrap',
			responsive: {
				1024: {
					disable: true
				}
			}
		} );
	};
}

export {IconicSticky};